// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { EnquiryResponseNewCustomerFragmentDoc } from '../enquiryResponseNewCustomer.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateEnquiryContactUsNewCustomerDocument = gql`
    mutation createEnquiryContactUsNewCustomer($input: EnquiryContactUsInput!, $customer: CustomerRegistrationInput!, $isConsultant: Boolean!) {
  createEnquiryContactUsNewCustomer(input: $input, customer: $customer) {
    ...enquiryResponseNewCustomer
  }
}
    ${EnquiryResponseNewCustomerFragmentDoc}`;

export function useCreateEnquiryContactUsNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.CreateEnquiryContactUsNewCustomerMutation, SchemaTypes.CreateEnquiryContactUsNewCustomerMutationVariables>(CreateEnquiryContactUsNewCustomerDocument);
};